export default "__VITE_ASSET__DMwZ38Vt__"